"use client"

import { useEffect, useState } from "react"
import {
  Typography,
  Button,
  IconButton,
  Box,
  Container,
  TextField,
  InputAdornment,
  Chip,
  useTheme,
  useMediaQuery,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Divider,
  Grid,
  Card,
  CardMedia,
  CardContent,
  InputLabel,
  Paper,
  InputBase,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Stepper,
  Step,
  StepLabel,
  ImageList,
  ImageListItem,
  ImageListItemBar,
  MenuItem,
} from "@mui/material"
import LocalParkingIcon from "@mui/icons-material/LocalParking"
import EmailIcon from "@mui/icons-material/Email"
import { Link } from '@mui/material';
import { Stack } from "@mui/material";

import {
  Search as SearchIcon,
  Close as CloseIcon,
  Facebook,
  Twitter,
  Instagram,
  LinkedIn,
  SquareFoot,
  VisibilityOff,
  Visibility,
  Send,
} from "@mui/icons-material"
import DashboardIcon from "@mui/icons-material/Dashboard"
import SecurityIcon from "@mui/icons-material/Security"
import SupportAgentIcon from "@mui/icons-material/SupportAgent"

import { Images } from "../../../assets/images"
import Loader from "../../../components/Loader"

import Colors from "../../../assets/styles"
import { useForm } from "react-hook-form"
import SimpleDialog from "../../../components/Dialog"
import { useNavigate } from "react-router-dom"
import moment from "moment"
import AuthServices from "../../../api/AuthServices/auth.index"
import { ErrorToaster, SuccessToaster } from "../../../components/Toaster"
import FileServices from "../../../api/FileServices/file.index"
import { useAuth } from "../../../context"
import PropertyServices from "../../../api/PropertyServices/property.index"
import Header from "../Header"
import CloudUploadIcon from "@mui/icons-material/CloudUpload"
import { trackGtmEvent } from "../../../utils/gtm"

const Home = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("md"))
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const [searchValue, setSearchValue] = useState("")
  const [selectedType, setSelectedType] = useState("")
  const [activeStep, setActiveStep] = useState(0)
  // const [selectedTime, setSelectedTime] = useState(null);

  const [showPassword, setShowPassword] = useState(false)
  const [loading, setLoading] = useState(false)
  const [openBookDialog, setOpenBookDialog] = useState(false)
  const [properties, setProperties] = useState([])
  const navigate = useNavigate()
  const [propertyData, setPropertyData] = useState([])
  const [maxMin, setMaxMin] = useState(null)
  const [bookingLoading, setBookingLoading] = useState(false)
  const [openFilterModal, setOpenFilterModal] = useState(false)
  const [openBookRegisterDialog, setOpenBookRegisterDialog] = useState(false)
  const [openRequestDialog, setOpenRequestDialog] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null)
  const [images, setImages] = useState(null)
  const [docLoading, setDocLoading] = useState(false)
  const [imgLoading, setImgLoading] = useState(false)
  const [loader, setLoader] = useState(false)
  const [preview, setPreview] = useState(null)
  const [docPreview, setDocPreview] = useState(null)
  const [document, setDocument] = useState(null)

  const open = Boolean(anchorEl)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }
  const itemData = [
    {
      img: Images.newItemData1,
      title: "GFS",
      author: "@bkristastucchio",
    },
    {
      img: Images.newItemData2,
      title: "Mex",
      author: "@rollelflex_graphy726",
    },
    {
      img: Images.newItemData3,
      title: "Refine",
      author: "@helloimnik",
    },
    {
      img: Images.newItemData4,
      title: "Wanta Shipping",
      author: "@nolanissac",
    },
  ]
  const handleUpload = async (e) => {
    setImgLoading(true)
    const formData = new FormData()
    const selectedFiles = Array.from(e.target.files)

    selectedFiles.forEach((file) => {
      formData.append("images", file)
    })

    try {
      const response = await FileServices.uploadImage(formData)
      console.log(response)
      setImages(response?.urls[0])
      setPreview(response?.urls[0])
      SuccessToaster(response?.message)
    } catch (error) {
      ErrorToaster(error)
    } finally {
      setImgLoading(false)
    }
  }
  const handleUploadDoc = async (e) => {
    setDocLoading(true)
    const formData = new FormData()
    const selectedFiles = Array.from(e.target.files)

    selectedFiles.forEach((file) => {
      formData.append("file", file)
    })

    try {
      const response = await FileServices.uploadDocument(formData)
      console.log(response)
      setDocument(response?.url)
      setDocPreview(response?.url)
      SuccessToaster(response?.message)
    } catch (error) {
      ErrorToaster(error)
    } finally {
      setDocLoading(false)
    }
  }

  const steps = ["Agent Information", "Booking Details"]

  const handleNext = async () => {
    const isValid = await trigger(["name", "phone", "address", "rearaid", "email", "password"])

    if (isValid) {
      clearErrors() // ✅ Jaise hi valid ho jaaye, purane errors hata do
      setActiveStep((prev) => prev + 1)
    }
  }

  const handleBack = () => {
    clearErrors() // ✅ Back karte hi bhi errors reset ho jaayein
    setActiveStep((prev) => prev - 1)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }
  const [filters, setFilters] = useState({
    propertyType: "",
    location: "",
    bedrooms: "",
    priceRange: [0, 10000000],
  })
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  })

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    })
  }

  const handleSubmit2 = (e) => {
    e.preventDefault()
    console.log("Form submitted:", formData)
    // Handle form submission here
  }
  const { WebUserLogin, webUser } = useAuth()
  const timeSlots = [
    "9-10",
    "10-11",
    "11-12",
    "12-13",
    "13-14",
    "14-15",
    "15-16",
    "16-17",
    "17-18",
    "18-19",
    "19-20",
    "20-21"
  ]
  const {
    register,
    handleSubmit,
    control,
    setValue,
    watch,
    reset,
    trigger,
    clearErrors,
    formState: { errors },
  } = useForm()

  const {
    register: registerRequest,
    handleSubmit: handleSubmitRequest,
    reset: resetRequest,
    formState: { errors: requestErrors },
  } = useForm();

  const selectedTime = watch("timeSlot")

  const handleMobileMenuToggle = () => {
    setMobileMenuOpen(!mobileMenuOpen)
  }

  const handleSearchChange = (event) => {
    setSearchValue(event.target.value)
  }

  const handleSearch = () => {
    const params = new URLSearchParams()

    if (filters.location) {
      params.append("location", filters.location)
    }

    if (filters.propertyType) {
      params.append("type", filters.propertyType)
    }

    // if (filters.priceRange?.length === 2) {
    //   params.append("priceMin", filters.priceRange[0]);
    //   params.append("priceMax", filters.priceRange[1]);
    // }
    if (selectedType) {
      params.append("purpose", selectedType.toLowerCase())
    }

    navigate(`/property-list?${params.toString()}`)
  }

  const mobileMenu = (
    <Drawer
      anchor="left"
      open={mobileMenuOpen}
      onClose={handleMobileMenuToggle}
      sx={{
        "& .MuiDrawer-paper": {
          width: 280,
          backgroundColor: "#fff",
        },
      }}
    >
      <Box
        sx={{
          p: 2,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="h6" sx={{ color: "#4a5568" }}>
          Menu
        </Typography>
        <IconButton onClick={handleMobileMenuToggle}>
          <CloseIcon />
        </IconButton>
      </Box>
      <Divider />
      <List>
        <ListItem button>
          <ListItemText primary="Sign Up / Sign In" />
        </ListItem>
      </List>
    </Drawer>
  )
  const getProperties = async (searchParam = "", idParam = "", pageParam = 1, limitParam = 4) => {
    setLoading(true)
    try {
      const { data } = await PropertyServices.getProperty(searchParam, idParam, pageParam, limitParam, "", "", "", "")
      setProperties(data?.properties)
      setMaxMin(data)
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }
  const features = [
    {
      icon: <DashboardIcon fontSize="large" color="primary" />,
      title: "Smart Dashboard",
      description: "Manage everything in one place with real-time updates.",
    },
    {
      icon: <SecurityIcon fontSize="large" color="primary" />,
      title: "Secure Platform",
      description: "Your data is encrypted and protected at every step.",
    },
    {
      icon: <SupportAgentIcon fontSize="large" color="primary" />,
      title: "24/7 Support",
      description: "Get round-the-clock assistance from our expert team.",
    },
  ]
  const cardData = [
    {
      title: "Office Furniture",
      description:
        "With our global network of furniture suppliers and in-house joinery fit out, spanning 20,000 sqft, we offer our clients a complete furniture and ergonomic solutions, enhancing your workspace’s comfort.",
      image: Images.expertcard1,
    },
    {
      title: "Design & Build",
      description:
        "As a top interior design and build company in the UAE, we specialise in creating workspaces that reflect your identity. Our expert in-house team ensures your design aligns with your values.",
      image: Images.expertcard2,
    },
    {
      title: "Office Fit-Out",
      description:
        "Let our experienced team of fit-out contractors manage your office fit-out, and we’ll create the perfect, ergonomic environment that reflects your unique brand identity but also engages your employees.",
      image: Images.expertcard3,
    },
    {
      title: "Office Refurbishment",
      description:
        "Refurbishing your office is an excellent chance to breathe new life into your workspace. This process allows you to reinvent and revitalize your work environment, enhancing both aesthetics and functionality.",
      image: Images.expertcard4,
    },
  ]

  useEffect(() => {
    getProperties("", "", 1, 8, "", "", "", "")
  }, [])

  const handlePropertyClick = (propertyName) => {
    console.log(`Clicked on ${propertyName}`)
  }

  const socialLinks = [
    { icon: <Facebook />, name: "Facebook", url: "#" },
    { icon: <Twitter />, name: "Twitter", url: "#" },
    { icon: <Instagram />, name: "Instagram", url: "#" },
    { icon: <LinkedIn />, name: "LinkedIn", url: "#" },
  ]

  const onSubmit = async (data) => {
    setBookingLoading(true)
    const obj = {
      name: webUser?.name,
      email: webUser?.email,
      agent_id: webUser?._id,
      property_id: propertyData?._id,
      // doc: document,
      date: data?.date,
      time: data?.timeSlot,
      client_name: data?.clientName,
      notes: data?.notes,
    }
    console.log(obj)
    try {
      const response = await AuthServices.createBooking(obj)

      trackGtmEvent("book_visit_submit", {
        property_id: propertyData?._id,
        property_name: propertyData?.name,
        visit_date: data?.date,
        visit_time: data?.timeSlot,
      });

      SuccessToaster(response?.message)
      setOpenBookDialog(false)
      reset()
      setValue("timeSlot", "")
      // setDocument(null);
    } catch (error) {
      ErrorToaster(error)
    } finally {
      setBookingLoading(false)
    }
  }
  const onRequestListingSubmit = async (data) => {
    setBookingLoading(true);
    const obj = {
      name: webUser?.name,
      email: webUser?.email,
      agent_id: webUser?._id,
      property_id: propertyData?._id,
      from_date: data?.fromDate,
      to_date: data?.toDate,
      client_type: data?.clientType,
      purpose: data?.purpose,
    };
    try {
      const response = await AuthServices.createRequestListing(obj);
      trackGtmEvent("request_listing_submit", {
        property_id: propertyData?._id,
        property_name: propertyData?.name,
        client_type: data?.clientType,
        purpose: data?.purpose,
      });
      SuccessToaster(response?.message);
      setOpenRequestDialog(false);
      resetRequest();
    } catch (error) {
      ErrorToaster(error);
    } finally {
      setBookingLoading(false);
    }
  }
  const onSubmit2 = async (data) => {
    setBookingLoading(true)
    const obj = {
      property_id: propertyData?._id,

      date: data?.date,
      time: data?.timeSlot,
      client_name: data?.clientName,
      notes: data?.notes,

      name: data.name,
      email: data.email,
      password: data.password,
      phone: data.phone,
      address: data.address,
      image: images,
      rera_id: data.rearaid,
      rera_doc: document,
    }
    console.log(obj)
    try {
      const response = await AuthServices.registerBooking(obj)

      trackGtmEvent("agent_signup", {
        method: "home_booking",
        rera_id: data.rearaid,
      });
      trackGtmEvent("book_visit_submit", {
        property_id: propertyData?._id,
        visit_date: data?.date,
        visit_time: data?.timeSlot,
      });

      SuccessToaster(response?.message)
      setOpenBookRegisterDialog(false)
      reset()
      setValue("timeSlot", "")
      setImages(null)
      setDocument(null)
      setPreview(null)
      setActiveStep(0)
      // setDocument(null);
    } catch (error) {
      ErrorToaster(error)
    } finally {
      setBookingLoading(false)
    }
  }

  const developers = [
    { name: "DAMAC", logo: Images.hero1 },
    { name: "EMAAR", logo: Images.hero2 },
    { name: "MERAAS", logo: Images.hero3 },
    { name: "SOBHA", logo: Images.hero4 },
    { name: "NAKHEEL", logo: Images.hero5 },
    { name: "Sobha", logo: Images.hero6 },
    { name: "Sobha", logo: Images.hero7 },
    { name: "Sobha", logo: Images.hero8 },
  ]
  const formatPrice = (price) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "AED",
      minimumFractionDigits: 0,
    }).format(price)
  }

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Header />

      {/* Hero */}
      <Box
        sx={{
          position: "relative",
          width: "100%",
          height: "100vh", // Full screen height
          overflow: "hidden",
        }}
      >
        {/* Background Image */}
        <Box
          component="img"
          src={Images.RRBanner}
          alt="Ready offices background"
          sx={{
            position: "absolute",
            inset: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
            objectPosition: "center",
            zIndex: 0,
          }}
        />

        {/* Overlay */}
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            zIndex: 1,
          }}
        />

        {/* Centered Content */}
        <Container
          sx={{
            position: "relative",
            zIndex: 2,
            height: "100%",
            display: "flex",
            justifyContent: "center",  // Horizontal Center
            alignItems: "center",      // Vertical Center
            textAlign: "center",

            transform: "translateY(-30px)", // Moves text up by 20px
          }}
        >
          <Box
            sx={{
              color: "white",
              px: { xs: 2, md: 0 },
              maxWidth: "800px",
            }}
          >
            <Typography
              variant="h2"
              sx={{
                mb: 2,
                fontSize: { md: "25px", sm: "25px", xs: "25px" },

              }}
            >
              <span style={{ lineHeight: 1.1, fontFamily: "'Gotham-Light', sans-serif", textTransform: "uppercase", fontWeight: 300, color: "rgba(255, 255, 255, 0.7)", letterSpacing: 8.5, fontSize: "45px", }}>
                Real Assets
              </span>
              <br />
              <span style={{
                fontFamily: "'Gotham-Light', serif", textTransform: "uppercase", fontSize: "70px", letterSpacing: 8.3,
              }}>
                Real Returns
              </span>
            </Typography>

            <Typography
              variant="h6"
              sx={{
                fontWeight: 400,
                opacity: 0.95,
                fontFamily: "'Gotham-Book',sans-serif",
                textShadow: "1px 1px 2px rgba(0,0,0,0.5)",
                maxWidth: 680,
                mx: "auto",
              }}
            >
              Connecting investors with high-yield commercial opportunities<br />
              in Dubai’s most dynamic business districts.
            </Typography>



            {/* Top Tabs (Buy, Rent, Off Plan) */}
            {webUser?.token && (
              <Box
                sx={{
                  display: { md: "flex", sm: "none", xs: "none" },
                  gap: 1.5,
                  mb: 2,
                }}
              >
                {["Sale", "Rent", "Both"].map((label) => (
                  <Button
                    key={label}
                    variant="outlined"
                    onClick={() => setSelectedType(label)}
                    sx={{
                      color: "white",
                      borderColor: "white",
                      borderRadius: "8px",
                      px: 3,
                      textTransform: "none",
                      backgroundColor:
                        selectedType === label ? Colors.primary : "transparent",
                      "&:hover": {
                        backgroundColor:
                          selectedType === label
                            ? Colors.primary
                            : "rgba(255,255,255,0.1)",
                      },
                    }}
                  >
                    {label}
                  </Button>
                ))}
              </Box>
            )}

            {/* Links at the bottom */}
            <Box
              sx={{
                position: "absolute",
                bottom: 0,
                left: 0,
                right: 0,
                display: "flex",
                justifyContent: "center", // Center links at bottom
                gap: 4,
                px: 4,
                py: 2,
                zIndex: 2,
              }}
            >

            </Box>
          </Box>
        </Container >

      </Box >


      {/* <Box
        sx={{
          minHeight: { xs: "70vh", md: "80vh" },
          backgroundImage: `url(${Images.banner})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          display: "flex",
          alignItems: "center",
          position: "relative",
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.3)",
            zIndex: 1,
          },
        }}
      >
        <Container maxWidth="lg" sx={{ position: "relative", zIndex: 2 }}>
          <Box
            sx={{
              textAlign: "center",
              color: "white",
              px: { xs: 2, md: 0 },
            }}
          >
            <Typography
              variant="h1"
              sx={{
                fontSize: {
                  xs: "2.5rem",
                  sm: "3.5rem",
                  md: "4.5rem",
                  lg: "5rem",
                },
                fontWeight: 700,
                mb: 2,
                lineHeight: 1.1,
                textShadow: "2px 2px 4px rgba(0,0,0,0.5)",
              }}
            >
              Discover Your New Home
            </Typography>

            <Typography
              variant="h5"
              sx={{
                fontSize: { xs: "1.1rem", sm: "1.3rem", md: "1.5rem" },
                fontWeight: 400,
                mb: 4,
                opacity: 0.95,
                textShadow: "1px 1px 2px rgba(0,0,0,0.5)",
              }}
            >
              Helping 100 Helping over 100 million renters find the perfect
              place to call home — with ease, confidence, and convenience.
              renters find their perfect fit.
            </Typography>

            <Box
              sx={{
                maxWidth: 600,
                mx: "auto",
                px: { xs: 2, sm: 0 },
              }}
            >
              <TextField
                fullWidth
                value={searchValue}
                onChange={handleSearchChange}
                placeholder="Enter city, state, or ZIP code"
                variant="outlined"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={handleSearch}
                        sx={{
                          backgroundColor: Colors.primary,
                          color: "white",
                          "&:hover": {
                            backgroundColor: Colors.primary,
                            opacity: 0.8,
                          },
                        }}
                      >
                        <SearchIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                  sx: {
                    backgroundColor: "white",
                    borderRadius: "50px",
                    fontSize: { xs: "0.9rem", sm: "1rem" },
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "none",
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      border: "none",
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      border: `2px solid ${Colors.primary}`,
                    },
                  },
                }}
                sx={{
                  "& .MuiInputBase-input": {
                    py: { xs: 1.5, sm: 2 },
                    px: 3,
                    fontSize: { xs: "0.9rem", sm: "1rem" },
                  },
                }}
              />
            </Box>
          </Box>
        </Container>
      </Box> */}

      {/* <Box sx={{ bgcolor: "#f4f8fb", py: 6 }}>
        <Container>
          <Grid
            container
            spacing={4}
            alignItems="center"
            justifyContent="center"
          >
            <Grid item xs={12} md={2}>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { xs: "1rem", md: "1.2rem" },
                  color: "#1a1a1a",
                  textAlign: { xs: "center", md: "left" },
                  fontWeight: 500,
                }}
              >
                Partners with Dubai’s leading developers
              </Typography>
            </Grid>

            <Grid item xs={12} md={10}>
              <Box
                sx={{
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                }}
              >
                <Box
                  sx={{
                    display: "inline-flex",
                    animation: "scrollLeft 30s linear infinite",
                  }}
                >
                  {developers.concat(developers).map((dev, idx) => (
                    <Box
                      key={idx}
                      sx={{
                        px: 2,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Box
                        component="img"
                        src={dev.logo}
                        alt={dev.name}
                        sx={{
                          maxWidth: "100px",
                          height: "auto",
                          objectFit: "contain",
                        }}
                      />
                    </Box>
                  ))}
                </Box>

                
                <style>
                  {`
        @keyframes scrollLeft {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
      `}
                </style>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box> */}
      {/*  Drawer */}
      {

        <Box sx={{ py: { xs: 4, md: 6 }, backgroundColor: "#f8f9fa" }}>


          <Container sx={{ maxWidth: "1300px !important" }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <Typography
                variant="h3"
                component="h2"
                sx={{
                  fontSize: { xs: "20px", sm: "2.25rem", md: "2.75rem" },
                  fontWeight: 600,
                  color: "#2d3748",

                }}
              >

              </Typography>
              <Box sx={{ display: "flex", justifyContent: "center" }}>
                <a
                  href="/property-list"
                  style={{
                    display: "inline-block",
                    padding: "12px 24px",
                    fontSize: "16px",
                    fontWeight: 400,
                    textDecoration: "none",
                    color: Colors.primary,
                    textAlign: "center",
                    borderRadius: "8px",
                    transition: "all 0.3s ease-in-out",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.opacity = 0.8;
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.opacity = 1;
                  }}
                >
                  View More +
                </a>
              </Box>
            </Box>

            <Grid container spacing={{ xs: 2, sm: 3, md: 4 }} sx={{ mb: 4, justifyContent: "center" }}>
              {properties.map((property) => (
                <Grid item xs={12} sm={6} lg={3} sx={{ paddingLeft: "18px !important" }} key={property.id}>
                  <Card
                    sx={{
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      borderRadius: 3,

                      boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                      transition: "all 0.3s ease-in-out",
                      cursor: "pointer",
                      overflow: "hidden",
                      "&:hover": {
                        transform: "translateY(-4px)",
                        boxShadow: "0 8px 25px rgba(0,0,0,0.15)",
                      },
                    }}
                    onClick={(e) => {
                      e.stopPropagation()

                      if (webUser?.token) {
                        navigate(`/property-detail/${property._id}`)
                      } else {
                        navigate("/agent/login")
                        ErrorToaster("Please login to View Detail")
                      }
                    }}
                  >
                    <CardMedia
                      component="img"
                      height={isMobile ? "200" : "250"}
                      image={property.images[0]}
                      alt={`${property.name} - ${property.type === 'commercialOffice' ? 'Commercial Office' : property.type || 'Property'} in Dubai`}
                      sx={{ objectFit: "cover" }}
                    />

                    <CardContent
                      sx={{
                        flexGrow: 1,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        p: { xs: 2, sm: 2 },
                      }}
                    >
                      {/* Title */}
                      <Typography
                        variant="h6"
                        component="h3"
                        sx={{
                          fontWeight: 600,
                          fontSize: { xs: "1.1rem", sm: "1.25rem" },
                          color: "#2d3748",
                          textAlign: "center",
                          mb: 1,
                        }}
                      >
                        {property.name}
                      </Typography>

                      {/* Address & Type */}
                      <Box sx={{ textAlign: "center", mb: 2 }}>
                        <Typography
                          variant="body2"
                          sx={{
                            color: "#718096",
                            fontSize: "0.9rem",
                            lineHeight: 1.4,
                            textTransform: "capitalize",
                          }}
                        >
                          {property.category}
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{
                            color: "#718096",
                            fontSize: "0.9rem",
                            lineHeight: 1.4,
                          }}
                        >
                          {property.type === "commercialOffice" ? "Commercial Office" : ""}
                        </Typography>
                      </Box>

                      {/* Beds, Baths, Area */}
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          gap: 2,
                          mb: 2,
                          color: "#4a5568",
                        }}
                      >
                        <Box display="flex" alignItems="center">
                          <LocalParkingIcon fontSize="small" />
                          <Typography variant="body2">{property.parking_space}</Typography>
                        </Box>

                        <Box display="flex" alignItems="center">
                          <SquareFoot fontSize="small" />
                          <Typography variant="body2">{property.area} sqft</Typography>
                        </Box>
                      </Box>

                      {/* Action Buttons */}
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          gap: 1,
                        }}
                      >
                        <Button
                          fullWidth
                          variant="contained"
                          size="small"
                          sx={{
                            backgroundColor: Colors.primary,
                            color: "white",
                            display: "none",
                            textTransform: "none",
                            fontWeight: 500,
                            "&:hover": {
                              backgroundColor: Colors.primary,
                              opacity: 0.8,
                            },
                          }}
                          onClick={(e) => {
                            e.stopPropagation()
                            if (webUser?.token) {
                              e.stopPropagation()

                              setPropertyData(property)
                              setOpenBookDialog(true)
                            } else {
                              e.stopPropagation()
                              setPropertyData(property)
                              setOpenBookRegisterDialog(true)

                              // navigate("/agent/login");
                              ErrorToaster("Please Fill Form to book a property")
                            }
                          }}
                        >
                          Book a visit
                        </Button>
                        <Button
                          fullWidth
                          variant="contained"
                          size="small"
                          sx={{
                            backgroundColor: Colors.primary,
                            color: "white",
                            display: "none",
                            textTransform: "none",
                            fontWeight: 500,
                            "&:hover": {
                              backgroundColor: Colors.primary,
                              opacity: 0.8,
                            },
                          }}
                          onClick={(e) => {
                            e.stopPropagation()
                            if (webUser?.token) {
                              e.stopPropagation()

                              setPropertyData(property)
                              setOpenRequestDialog(true);
                            } else {
                              e.stopPropagation()
                              setPropertyData(property)
                              setOpenRequestDialog(true)

                              // navigate("/agent/login");
                              ErrorToaster("Please Fill Form to request a property")
                            }
                          }}
                        >
                          Request listing
                        </Button>
                        <Button
                          fullWidth
                          variant="outlined"
                          size="small"
                          sx={{
                            color: "#3a84a6",
                            borderColor: "#3a84a6",
                            textTransform: "none",
                            fontWeight: 500,
                            "&:hover": {
                              borderColor: "#2f6e8b",
                              color: "#2f6e8b",
                            },
                          }}
                          onClick={(e) => {
                            e.stopPropagation()

                            if (webUser?.token) {
                              navigate(`/property-detail/${property._id}`)
                            } else {
                              ErrorToaster("Please login to View Detail")
                              navigate("/agent/login")
                            }
                          }}
                        // onClick={() =>
                        //   navigate(`/property-detail/${property._id}`)
                        // }
                        >
                          View Details
                        </Button>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>

            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <Button
                variant="contained"
                size="large"
                onClick={() => navigate("/property-list")}
                sx={{
                  backgroundColor: Colors.primary,
                  color: "white",
                  px: { md: 6, sm: 5, xs: 4 },
                  py: 2,
                  fontSize: "15px",
                  fontWeight: 600,
                  textTransform: "none",
                  borderRadius: 2,
                  boxShadow: "0 4px 12px rgba(34, 197, 94, 0.3)",
                  "&:hover": {
                    backgroundColor: Colors.primary,
                    boxShadow: "0 6px 20px rgba(34, 197, 94, 0.4)",
                    transform: "translateY(-2px)",
                    opacity: 0.8,
                  },
                  transition: "all 0.3s ease-in-out",
                }}
              >
                Browse All Properties
              </Button>
            </Box>
          </Container>





        </Box>

      }

      {/* //new intro blue listing  */}
      <Box sx={{ py: { xs: 4, md: 3 }, background: "linear-gradient(to bottom, #081434 30%, #112d55 70%)", }}>
        <Container sx={{ maxWidth: "1300px !important" }}>

          <Container maxWidth="lg">
            <Box sx={{ textAlign: "center", mb: { xs: 4, md: 6 } }}>
              {/* Logo */}
              <Box sx={{ display: "flex", justifyContent: "center", mb: 4, mt: 2 }}>
                <img
                  src={Images.RRCenterLogo}
                  alt="Centered Image"
                  style={{ maxWidth: "100%", height: "auto" }}
                />
              </Box>

              {/* Two Columns */}
              <Grid
                container
                spacing={6} // spacing between columns
                justifyContent="center" // center the whole grid
                alignItems="center"
                sx={{ mt: 2 }}
              >
                {/* Left Column - Text */}
                <Grid item xs={12} md={5}>
                  <Typography
                    variant="h6"
                    sx={{
                      fontSize: { xs: "1rem", sm: "1.1rem", md: "1.70rem" },
                      color: Colors.primary,
                      textAlign: "left",
                      fontWeight: 600,
                      fontFamily: "'Copperplate-Gothic-32-BC',sans-serif",
                      mb: 2,
                    }}
                  >
                    Access Exclusive Listings
                  </Typography>
                  <Typography variant="body1" sx={{ color: "#fff", lineHeight: 1.7, textAlign: "left", fontFamily: "'Gotham-Book',sasn-serif" }}>
                    Unlock a curated selection of premium properties tailored for discerning investors. Log in to explore opportunities designed to deliver long-term value and stability.
                  </Typography>
                  <br /><br />
                  <Box sx={{ display: "flex", gap: 1 }}>
                    <Button
                      size="medium"
                      onClick={() => navigate("/login")}
                      sx={{
                        backgroundColor: "#a58158",
                        color: "#112d55",
                        fontSize: "16px",
                        fontWeight: 400,
                        borderRadius: "0",
                        px: 3,
                        textTransform: "none",
                        "&:hover": {
                          backgroundColor: Colors.primary,
                          opacity: 0.8,
                        },
                      }}
                    >
                      Log in
                    </Button>

                    <Button
                      variant="outlined"
                      size="medium"
                      onClick={() => navigate("/agent/signup")}
                      sx={{
                        backgroundColor: "#112d55",
                        color: "white",
                        px: 3,
                        fontSize: "16px",
                        borderWidth: "1",
                        borderColor: "#fff",
                        borderRadius: "0",
                        fontWeight: 400,
                        textTransform: "none",
                      }}
                    >
                      Register
                    </Button>
                  </Box>

                </Grid>

                {/* Right Column - Image */}
                <Grid item xs={12} md={5}>
                  {/* Mobile Image */}
                  <Box
                    component="img"
                    src={Images.RRMaPM}
                    alt="Dubai Real Estate Investment"
                    sx={{
                      width: "100%",
                      height: "250px",
                      borderRadius: 2,
                      display: { xs: "block", md: "none" }, // Only on mobile
                    }}
                  />

                  {/* Desktop Image */}
                  <Box
                    component="img"
                    src={Images.RRMap}
                    alt="Dubai Real Estate Investment"
                    sx={{
                      width: "100%",
                      height: "350px",
                      borderRadius: 2,
                      display: { xs: "none", md: "block" }, // Only on desktop
                    }}
                  />
                </Grid>

              </Grid>
            </Box>
          </Container>

          {/* Second Container */}
          <Container maxWidth="lg" sx={{ textAlign: "center", my: { xs: 6, md: 4 } }}>
            <Box
              sx={{
                py: { xs: 4, md: 3 },
              }}
            >
              <Grid
                container
                spacing={4} // spacing between columns
                justifyContent="center" // center the whole grid
                alignItems="center"
              >
                {/* Left Column - 50+ Projects */}
                <Grid item xs={12} md={5}>
                  <Typography
                    variant="h4"
                    sx={{
                      fontSize: { xs: "2rem", md: "2.4rem" },
                      fontWeight: 700,
                      color: Colors.primary,

                      fontFamily: "'Copperplate-Gothic-32-BC', sans-serif",
                    }}
                  >
                    15+ YEARS
                  </Typography>
                  <Typography
                    variant="h6"
                    sx={{
                      fontSize: { xs: "1.2rem", md: "1.1rem" },
                      letterSpacing: 2.9,
                      textTransform: "uppercase",
                      color: Colors.primary,
                      fontWeight: 400,
                      fontFamily: "'Gotham-Light', sans-serif",
                    }}
                  >
                    Commercial Sector
                  </Typography>
                </Grid>

                {/* Right Column - 12,000 SQ FT */}
                <Grid item xs={12} md={5}>
                  <Typography
                    variant="h4"
                    sx={{
                      fontSize: { xs: "2rem", md: "2.4rem" },
                      fontWeight: 700,
                      color: Colors.primary,
                      fontFamily: "'Copperplate-Gothic-32-BC', sans-serif",
                    }}
                  >
                    120,000 sqft
                  </Typography>
                  <Typography
                    variant="h6"
                    sx={{
                      fontSize: { xs: "1.2rem", md: "1.1rem" },
                      letterSpacing: 2.9,
                      textTransform: "uppercase",
                      color: Colors.primary,
                      fontWeight: 400,
                      fontFamily: "'Gotham-Light', sans-serif",
                    }}
                  >
                    Development
                  </Typography>
                </Grid>
              </Grid>
            </Box>
            <Box
              sx={{
                py: { xs: 2, md: 1 },
                display: "flex",
                justifyContent: "center", // centers horizontally
                alignItems: "center",     // centers vertically
              }}
            >
              <img
                src={Images.RRGoldBan}
                style={{ maxWidth: "100%", height: "auto" }}
              />
            </Box>

          </Container>
        </Container>
      </Box>






      <Box
        sx={{
          backgroundImage: `url(${Images.banner2})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          position: "relative",

          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(180, 145, 104, 0.9)",
            zIndex: 1,
          },
        }}
      >
        <Container
          maxWidth="lg"
          sx={{
            position: "relative",
            zIndex: 2,
            py: { xs: 4, md: 8 },
          }}
        >

          <Box sx={{ textAlign: "center", mb: { xs: 4, md: 8 } }}>

            {/* Bold H2 heading */}
            <Typography
              variant="h2"
              component="h2"

              sx={{
                fontFamily: "'Copperplate-Gothic-32-BC', sans-serif",
                fontWeight: 800,
                color: "white",
                fontSize: { xs: "1.75rem", sm: "2.25rem", md: "3.5rem" },
                lineHeight: 1.1,
              }}
            >
              Contact us
            </Typography>


          </Box>
          <Grid container spacing={4} alignItems="stretch">
            <Grid item xs={12} md={6}>
              <Box
                sx={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
              >

                <Typography
                  variant="body1"
                  sx={{
                    color: "#fff",
                    mb: 2,
                    fontFamily: "'Gotham-Book',sans-serif",
                    fontWeight: 600,
                    fontSize: "1.1rem",
                    lineHeight: 1.6,
                  }}
                >
                  Let's Build Value Together
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    color: "#fff",
                    fontFamily: "'Gotham-Book',sans-serif",
                    mb: 2,
                    fontSize: "1.1rem",
                    lineHeight: 1.6,
                  }}
                >
                  At RR Properties, we believe every great partnership begins with a conversation. Whether you're an investor seeking exceptional returns, a business looking for premium commercial space, or a partner exploring collaboration, we'd love to hear from you.
                </Typography>

                <Box sx={{ my: 2 }}>
                  <Typography variant="h6" sx={{ fontWeight: "bold", fontFamily: "'Gotham-Book',sans-serif", mb: 1, color: "#fff" }}>
                    Why Reach Out to Us?
                  </Typography>

                  <List
                    sx={{
                      color: "#fff",
                      fontFamily: "'Gotham-Book',sans-serif",
                      lineHeight: 1.8,
                      listStyleType: "disc",
                      pl: 3,
                    }}
                  >
                    <ListItem sx={{ display: "list-item", p: 0 }}>
                      Exclusive investment opportunities with proven ROI
                    </ListItem>
                    <ListItem sx={{ display: "list-item", p: 0 }}>
                      Premium office spaces tailored to modern business needs
                    </ListItem>
                    <ListItem sx={{ display: "list-item", p: 0 }}>
                      Trusted partner with a track record of market succes
                    </ListItem>
                  </List>
                </Box>
                <Button
                  component="a"
                  href="mailto:info@prroperties.ae"
                  variant="contained"
                  size="large"
                  startIcon={<EmailIcon />}
                  sx={{
                    fontFamily: "'Gotham-Book',sans-serif",
                    textTransform: "none",
                    fontWeight: 600,
                    borderRadius: 0,
                    color: "#ffffff",
                    py: 1.5,
                    backgroundColor: Colors.darkblue,
                    width: { xs: "100%", md: "330px" },
                    fontSize: { xs: "12px", md: "14px" },
                  }}
                >
                  Let's Discuss Your Next Investment
                </Button>
              </Box>
            </Grid>

            <Grid item xs={12} md={6}>
              <Paper
                elevation={0}
                sx={{
                  p: { xs: 3, md: 4 },
                  backgroundColor: "transparent",
                  height: "100%",
                }}
              >
                <Box
                  component="form"
                  onSubmit={handleSubmit2}
                  sx={{ display: "flex", flexDirection: "column", gap: 3 }}
                >
                  <Box>
                    <Typography
                      variant="body1"
                      sx={{
                        color: "#fff",
                        mb: 1,
                        fontSize: "1rem",
                        fontFamily: "'Gotham-Book',sans-serif",
                      }}
                    >
                      Your Name
                      <Typography component="span" sx={{ color: "#d32f2f", ml: 0.5 }}>
                        *
                      </Typography>
                    </Typography>
                    <TextField
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      fullWidth
                      required
                      variant="outlined"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          backgroundColor: "rgba(255, 255, 255, 0.8)",
                          "& fieldset": {
                            borderColor: "#ddd",
                          },
                          "&:hover fieldset": {
                            borderColor: "#bbb",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#2c3e50",
                          },
                        },
                      }}
                    />
                  </Box>

                  <Box>
                    <Typography
                      variant="body1"
                      sx={{
                        color: "#fff",
                        mb: 1,
                        fontSize: "1rem",
                        fontFamily: "'Gotham-Book',sans-serif",
                      }}
                    >
                      Your Email
                    </Typography>
                    <TextField
                      name="email"
                      type="email"
                      value={formData.email}
                      onChange={handleChange}
                      fullWidth
                      required
                      variant="outlined"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          backgroundColor: "rgba(255, 255, 255, 0.8)",
                          "& fieldset": {
                            borderColor: "#ddd",
                          },
                          "&:hover fieldset": {
                            borderColor: "#bbb",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#2c3e50",
                          },
                        },
                      }}
                    />
                  </Box>

                  <Box>
                    <Typography
                      variant="body1"
                      sx={{
                        color: "#fff",
                        mb: 1,
                        fontSize: "1rem",
                        fontFamily: "'Gotham-Book',sans-serif",
                      }}
                    >
                      Your Message
                    </Typography>
                    <TextField
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      fullWidth
                      required
                      multiline
                      rows={6}
                      variant="outlined"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          backgroundColor: "rgba(255, 255, 255, 0.8)",
                          "& fieldset": {
                            borderColor: "#ddd",
                          },
                          "&:hover fieldset": {
                            borderColor: "#bbb",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#2c3e50",
                          },
                        },
                      }}
                    />
                  </Box>

                  <Button
                    type="submit"
                    variant="contained"
                    endIcon={<Send />}
                    sx={{
                      backgroundColor: Colors.darkblue,
                      fontFamily: "'Gotham-Book',sans-serif",
                      color: "white",
                      py: 1.5,
                      px: 4,
                      fontSize: "1rem",
                      fontWeight: 600,
                      textTransform: "none",
                      borderRadius: 0,
                      alignSelf: "flex-start",
                      fontSize: { xs: "12px", md: "14px" },

                    }}
                  >
                    Send Message
                  </Button>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* //Contact Form// */}

      {/* <Box sx={{ py: { xs: 6, md: 8 }, backgroundColor: "white" }}>
        <Container sx={{ maxWidth: "1300px !important" }}>
          <Box sx={{ textAlign: "center", mb: { xs: 4, md: 6 } }}>
            <Typography
              variant="h2"
              component="h2"
              sx={{
                fontSize: { xs: "2rem", sm: "2.5rem", md: "3rem" },
                fontWeight: 600,
                color: "#2d3748",
                mb: 2,
              }}
            >
              Success Stories
            </Typography>
            <Typography
              variant="h6"
              sx={{
                fontSize: { xs: "1rem", sm: "1.1rem", md: "1.25rem" },
                color: "#718096",
                fontWeight: 400,
                maxWidth: "600px",
                mx: "auto",
              }}
            >
              Real results from our investment partnerships
            </Typography>
          </Box>

          <Grid container spacing={{ xs: 3, md: 4 }}>
            {[
              {
                title: "JLT Office Complex",
                roi: "28% ROI",
                description:
                  "Transformed a dated office building into a premium workspace, achieving 100% occupancy within 3 months",
                image: "/placeholder.svg?height=200&width=300",
              },
              {
                title: "DIFC Commercial Tower",
                roi: "35% ROI",
                description:
                  "Strategic renovation and repositioning resulted in premium tenant acquisition and exceptional returns",
                image: "/placeholder.svg?height=200&width=300",
              },
              {
                title: "Business Bay Development",
                roi: "42% ROI",
                description:
                  "Complete fit-out investment delivering market-leading rental yields and long-term corporate contracts",
                image: "/placeholder.svg?height=200&width=300",
              },
            ].map((story, index) => (
              <Grid item xs={12} md={4} key={index}>
                <Paper
                  elevation={0}
                  sx={{
                    borderRadius: 3,
                    overflow: "hidden",
                    height: "100%",
                    border: "1px solid #e2e8f0",
                    transition: "all 0.3s ease-in-out",
                    "&:hover": {
                      transform: "translateY(-4px)",
                      boxShadow: "0 8px 25px rgba(0,0,0,0.1)",
                    },
                  }}
                >
                  <Box
                    component="img"
                    src={story.image}
                    alt={story.title}
                    sx={{
                      width: "100%",
                      height: 200,
                      objectFit: "cover",
                    }}
                  />
                  <Box sx={{ p: 3 }}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        mb: 2,
                      }}
                    >
                      <Typography variant="h6" sx={{ fontWeight: 600, color: "#2d3748" }}>
                        {story.title}
                      </Typography>
                      <Typography
                        sx={{
                          backgroundColor: Colors.primary,
                          color: "white",
                          px: 2,
                          py: 0.5,
                          borderRadius: 2,
                          fontSize: "0.875rem",
                          fontWeight: 600,
                        }}
                      >
                        {story.roi}
                      </Typography>
                    </Box>
                    <Typography sx={{ color: "#718096", lineHeight: 1.6 }}>{story.description}</Typography>
                  </Box>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box> */}



      {/* Footer */}

      <Box
        component="footer"
        sx={{
          backgroundColor: "#081534",
          color: "white",
          py: 6,
        }}
      >
        <Container maxWidth="xl">
          <Grid container spacing={2} alignItems="center">
            {/* Social Media Links */}
            <Grid item xs={12} md={4}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Typography
                  variant="body2"
                  sx={{
                    color: Colors.white,
                    fontFamily: "'Gotham-Book',sans-serif",
                    mr: 2,
                    display: { sm: "block" },
                  }}
                >
                  Contact Us at :{" "}
                  <Box
                    component="a"
                    href="mailto:info@prroperties.ae"
                    onClick={() =>
                      trackGtmEvent("contact", {
                        method: "email",
                        email: "info@prroperties.ae",
                      })
                    }
                    sx={{
                      color: Colors.white,
                      textDecoration: "underline",
                      textUnderlineOffset: "3px",
                      transition: "opacity 0.2s ease-in-out",
                      "&:hover": {
                        opacity: 0.8,
                      },
                    }}
                  >
                    info@prroperties.ae
                  </Box>
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={4}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Box
                  onClick={() => navigate("/")}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    cursor: "pointer",
                  }}
                >
                  <Box
                    component="img"
                    src={Images.RRLogo}
                    alt="RR Property Expert"
                    sx={{
                      width: { md: "100%", xs: "100%" },
                      height: { md: "60px", xs: "60px" },
                    }}
                  />
                </Box>
              </Box>
            </Grid>

            {/* Copyright & Legal */}
            <Grid item xs={12} md={4}>
              <Box
                sx={{
                  textAlign: { xs: "center", md: "right" },
                  display: "flex",
                  flexDirection: { xs: "column", sm: "row" },
                  alignItems: { xs: "center", md: "flex-end" },
                  justifyContent: { md: "flex-end" },
                  gap: { xs: 1, sm: 2 },
                }}
              >
                <Typography
                  variant="body2"
                  sx={{
                    color: Colors.white,
                    fontFamily: "'Gotham-Book',sans-serif",
                    fontSize: "0.875rem",
                  }}
                >
                  © {moment().format("YYYY")} All rights reserved.
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* Booking modal */}
      <SimpleDialog
        open={openBookDialog}
        onClose={() => {
          setOpenBookDialog(false)
          reset()
          setValue("timeSlot", "")
        }}
        border={`4px solid ${Colors.primary}`}
        title={`Book This Property`}
      >
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={2}>
            {/* Date Picker */}

            <Grid item xs={12} md={12}>
              <InputLabel>Select Date</InputLabel>

              <TextField
                type="date"
                fullWidth
                InputLabelProps={{
                  shrink: true,
                }}
                error={!!errors.date}
                helperText={errors.date?.message}
                {...register("date", { required: "Date is required" })}
              />
            </Grid>

            {/* Time Slot Chips */}
            <Grid item xs={12} md={12}>
              <InputLabel>Select Time Slot</InputLabel>
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 1 }}>
                {timeSlots.map((slot) => (
                  <Chip
                    key={slot}
                    label={slot}
                    clickable
                    color={selectedTime === slot ? "primary" : "default"}
                    onClick={() => setValue("timeSlot", slot, { shouldValidate: true })}
                  />
                ))}
              </Box>
              {errors.timeSlot && (
                <Typography color="error" variant="caption">
                  {errors.timeSlot.message}
                </Typography>
              )}
              {/* Hidden time slot input */}
              <input type="hidden" {...register("timeSlot", { required: "Time slot is required" })} />
            </Grid>

            {/* Document Upload */}
            {/* <Grid item xs={12} md={12}>
              <InputLabel>Upload Document</InputLabel>
              <Box
                component="label"
                sx={{
                  border: "2px dashed #ccc",
                  borderRadius: 2,
                  padding: 2,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  bgcolor: "#f9f9f9",
                  gap: 1,
                  flexDirection: "column",
                  textAlign: "center",
                }}
              >
                {docLoading ? (
                  <Loader width="30px" height="30px" color={Colors.primary} />
                ) : (
                  <>
                    <CloudUploadIcon sx={{ fontSize: 28, color: "#999" }} />
                    <Typography variant="caption">
                      {document ? `Document Uploaded` : "Upload RERA Document"}
                    </Typography>
                  </>
                )}
                <input
                  type="file"
                  accept=".pdf,.jpg,.jpeg,.png"
                  hidden
                  {...register("document", {
                    required: "Document is required",
                  })}
                  onChange={handleUploadDoc}
                />
              </Box>
              {errors.document && (
                <Typography color="error" variant="caption">
                  {errors.document.message}
                </Typography>
              )}
            </Grid> */}

            <Grid item xs={12} md={12}>
              <InputLabel>Client Name</InputLabel>

              <TextField
                type="text"
                fullWidth
                placeholder="Client Name"
                InputLabelProps={{
                  shrink: true,
                }}
                {...register("clientName")}
              />
            </Grid>

            <Grid item xs={12} md={12}>
              <InputLabel>Additional Notes </InputLabel>

              <TextField
                type="text"
                fullWidth
                placeholder="Type Additional Notes here"
                InputLabelProps={{
                  shrink: true,
                }}
                {...register("notes")}
              />
            </Grid>

            <Grid item xs={12}>
              <Typography variant="caption" color="textSecondary" sx={{ mt: 2 }}>
                This is private data, for registering purposes only.
              </Typography>
            </Grid>

            {/* Submit Button */}
            <Grid item xs={12}>
              <Button type="submit" variant="contained" sx={{ color: Colors.white }} fullWidth>
                {bookingLoading ? <Loader width="20px" height="20px" color={Colors.white} /> : "Book a visit"}
              </Button>
            </Grid>
          </Grid>
        </form>
      </SimpleDialog>

      <SimpleDialog
        open={openRequestDialog}
        onClose={() => {
          setOpenRequestDialog(false);
          reset();
        }}
        border={`4px solid ${Colors.primary}`}
        title={"Request Listing"}
      >
        <form onSubmit={handleSubmitRequest(onRequestListingSubmit)}>
          <Grid container spacing={2}>
            {/* Date Picker */}
            <Grid item xs={12} md={12}>
              <Box sx={{ display: "flex", gap: 2 }}>
                <Box sx={{ flex: 1 }}>
                  <InputLabel>Select From Date</InputLabel>
                  <TextField
                    type="date"
                    fullWidth
                    InputLabelProps={{
                      shrink: true,
                    }}
                    inputProps={{ min: new Date().toISOString().split("T")[0] }}
                    error={!!requestErrors.fromDate}
                    helperText={requestErrors.fromDate?.message}
                    {...registerRequest("fromDate", { required: "From Date is required" })}
                  />
                </Box>
                <Box sx={{ flex: 1 }}>
                  <InputLabel>Select To Date</InputLabel>
                  <TextField
                    type="date"
                    fullWidth
                    InputLabelProps={{
                      shrink: true,
                    }}
                    inputProps={{ min: new Date().toISOString().split("T")[0] }}
                    error={!!requestErrors.toDate}
                    helperText={requestErrors.toDate?.message}
                    {...registerRequest("toDate", { required: "To Date is required" })}
                  />
                </Box>
              </Box>
            </Grid>

            <Grid item xs={12} md={12}>
              <Box
                sx={{
                  display: "flex",
                  gap: 2,
                  flexDirection: { xs: "column", md: "row" }, // responsive
                }}
              >
                <Box sx={{ flex: 1 }}>
                  <InputLabel>Listing Type</InputLabel>
                  <TextField
                    select
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    error={!!requestErrors.clientType}
                    helperText={requestErrors.clientType?.message}
                    {...registerRequest("clientType", { required: "Listing type is required" })}
                  >
                    <MenuItem value="exclusive">Exclusive</MenuItem>
                    <MenuItem value="non-exclusive">Non Exclusive</MenuItem>
                  </TextField>
                </Box>

                <Box sx={{ flex: 1 }}>
                  <InputLabel>Purpose</InputLabel>
                  <TextField
                    select
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    error={!!requestErrors.purpose}
                    helperText={requestErrors.purpose?.message}
                    {...registerRequest("purpose", { required: "Purpose is required" })}
                  >
                    <MenuItem value="rent">Rent</MenuItem>
                    <MenuItem value="sale">Sale</MenuItem>
                  </TextField>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Button
                type="submit"
                variant="contained"
                sx={{ color: Colors.white }}
                fullWidth
              >
                {bookingLoading ? (
                  <Loader width="20px" height="20px" color={Colors.white} />
                ) : (
                  "Request listing"
                )}
              </Button>
            </Grid>
          </Grid>
        </form>
      </SimpleDialog>

      {/* Booking with register dialog */}
      <SimpleDialog
        open={openBookRegisterDialog}
        onClose={() => {
          setOpenBookRegisterDialog(false)
          reset()
          setValue("timeSlot", "")
          setImages(null)
          setDocument(null)
          setPreview(null)
          setDocPreview(null)
          setActiveStep(0)
        }}
        border={`4px solid ${Colors.primary}`}
        title={`Book This Property`}
      >
        <Box sx={{ width: "100%" }}>
          {/* Stepper */}
          <Stepper activeStep={activeStep} alternativeLabel sx={{ mb: 4 }}>
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>

          <form onSubmit={handleSubmit(onSubmit2)}>
            {activeStep === 0 && (
              <Grid container spacing={2}>
                {/* Agent Info */}
                <Grid item xs={12} md={6}>
                  <Typography variant="subtitle2" mb={1} textAlign="center">
                    Profile Picture
                  </Typography>

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Box
                      sx={{
                        position: "relative",
                        width: 80,
                        height: 80,
                        borderRadius: "50%",
                        overflow: "hidden",
                        border: "2px dashed #ccc",
                        bgcolor: "#f5f5f5",
                        "&:hover .overlay": {
                          opacity: 1,
                        },
                      }}
                    >
                      <Box
                        component="label"
                        htmlFor="profile-upload"
                        sx={{
                          width: "100%",
                          height: "100%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          cursor: "pointer",
                        }}
                      >
                        {imgLoading ? (
                          <Loader width="30px" height="30px" color={Colors.primary} />
                        ) : (
                          <Box
                            component="img"
                            src={preview || Images.default}
                            alt="Profile"
                            sx={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                              borderRadius: "50%",
                            }}
                          />
                        )}

                        <Box
                          className="overlay"
                          sx={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            bgcolor: "rgba(0, 0, 0, 0.4)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#fff",
                            opacity: 0,
                            transition: "opacity 0.3s ease",
                            fontSize: "12px",
                            borderRadius: "50%",
                          }}
                        >
                          Change
                        </Box>
                      </Box>

                      {/* Delete Icon */}
                      {preview && (
                        <IconButton
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation()
                            setPreview(null)
                          }}
                          sx={{
                            position: "absolute",
                            top: 3,
                            right: 3,
                            backgroundColor: "red",
                            color: "#fff",
                            "&:hover": { backgroundColor: "darkred" },
                            zIndex: 2,
                          }}
                        >
                          <CloseIcon fontSize="small" />
                        </IconButton>
                      )}
                    </Box>

                    <input
                      id="profile-upload"
                      type="file"
                      accept="image/*"
                      hidden
                      {...register("profilePic", {
                        onChange: (e) => handleUpload(e),
                      })}
                    />
                  </Box>
                </Grid>

                <Grid item xs={12} md={6}>
                  <Typography variant="subtitle2" mb={1}>
                    RERA Document
                  </Typography>
                  <Box
                    component="label"
                    sx={{
                      border: "2px dashed #ccc",
                      borderRadius: 2,
                      padding: 2,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      bgcolor: "#f9f9f9",
                      gap: 1,
                      flexDirection: "column",
                      textAlign: "center",
                    }}
                  >
                    {docLoading ? (
                      <Loader width="30px" height="30px" color={Colors.primary} />
                    ) : (
                      <>
                        <CloudUploadIcon sx={{ fontSize: 28, color: "#999" }} />
                        <Typography variant="caption">
                          {document ? `RERA Documnet Uploaded` : "Upload RERA Document"}
                        </Typography>
                      </>
                    )}
                    <input type="file" accept=".pdf,.jpg,.jpeg,.png" hidden onChange={handleUploadDoc} />
                  </Box>
                </Grid>

                {/* Input Fields */}
                {[
                  { name: "name", label: "Full Name", md: 6 },
                  {
                    name: "phone",
                    label: "Phone Number",
                    md: 6,
                    props: {
                      inputProps: { inputMode: "numeric", pattern: "[0-9]*" },
                      rules: {
                        pattern: {
                          value: /^[0-9]+$/,
                          message: "Only numbers are allowed",
                        },
                      },
                    },
                  },
                  { name: "address", label: "Address", md: 6 },
                  { name: "rearaid", label: "Rera Id", md: 6 },
                  {
                    name: "email",
                    label: "Email",
                    md: 6,
                    props: {
                      rules: {
                        pattern: {
                          value: /\S+@\S+\.\S+/,
                          message: "Enter a valid email",
                        },
                      },
                    },
                  },
                ].map(({ name, label, md, props = {} }) => (
                  <Grid key={name} item xs={12} md={md}>
                    <TextField
                      label={label}
                      fullWidth
                      {...register(name, {
                        required: `${label} is required`,
                        ...(props.rules || {}),
                      })}
                      error={!!errors[name]}
                      helperText={errors[name]?.message}
                      {...props}
                    />
                  </Grid>
                ))}

                {/* Password */}
                <Grid item xs={12} md={6}>
                  <TextField
                    label="Password"
                    fullWidth
                    type={showPassword ? "text" : "password"}
                    {...register("password", {
                      required: "Password is required",
                      minLength: {
                        value: 6,
                        message: "Minimum 6 characters required",
                      },
                    })}
                    error={!!errors.password}
                    helperText={errors.password?.message}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton onClick={() => setShowPassword((prev) => !prev)} edge="end" size="small">
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>

                {/* Next button */}
                <Grid item xs={12}>
                  <Button variant="contained" onClick={handleNext} sx={{ float: "right" }}>
                    Next
                  </Button>
                </Grid>
              </Grid>
            )}

            {activeStep === 1 && (
              <Grid container spacing={2}>
                {/* Date Picker */}
                <Grid item xs={12}>
                  <InputLabel>Select Date</InputLabel>
                  <TextField
                    type="date"
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    {...register("date", { required: "Date is required" })}
                    error={!!errors.date}
                    helperText={errors.date?.message}
                  />
                </Grid>

                {/* Time Slot Chips */}
                <Grid item xs={12}>
                  <InputLabel>Select Time Slot</InputLabel>
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 1 }}>
                    {timeSlots.map((slot) => (
                      <Chip
                        key={slot}
                        label={slot}
                        clickable
                        color={selectedTime === slot ? "primary" : "default"}
                        onClick={() => {
                          // setSelectedTime(slot);
                          setValue("timeSlot", slot, { shouldValidate: true })
                        }}
                      />
                    ))}
                  </Box>
                  {errors.timeSlot && (
                    <Typography color="error" variant="caption">
                      {errors.timeSlot.message}
                    </Typography>
                  )}
                  <input
                    type="hidden"
                    {...register("timeSlot", {
                      required: "Time slot is required",
                    })}
                  />
                </Grid>

                <Grid item xs={12} md={12}>
                  <InputLabel>Client Name</InputLabel>

                  <TextField
                    type="text"
                    fullWidth
                    placeholder="Client Name"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    {...register("clientName")}
                  />
                </Grid>

                {/* Notes */}
                <Grid item xs={12}>
                  <InputLabel>Additional Notes</InputLabel>
                  <TextField fullWidth placeholder="Type Additional Notes here" {...register("notes")} />
                </Grid>

                <Grid item xs={12}>
                  <Typography variant="caption" color="textSecondary" sx={{ mt: 2 }}>
                    This is private data, for registering purposes only.
                  </Typography>
                </Grid>

                {/* Buttons */}
                <Grid item xs={12} sx={{ display: "flex", gap: 2 }}>
                  <Button variant="outlined" onClick={handleBack} fullWidth>
                    Back
                  </Button>
                  <Button type="submit" variant="contained" sx={{ color: Colors.white }} fullWidth>
                    {bookingLoading ? <Loader width="20px" height="20px" color={Colors.white} /> : "Book a visit"}
                  </Button>
                </Grid>
              </Grid>
            )}
          </form>
        </Box>
      </SimpleDialog>

      <Dialog open={openFilterModal} onClose={() => setOpenFilterModal(false)} fullWidth sx={{ borderRadius: 2 }}>
        <DialogTitle sx={{ fontWeight: "bold", fontSize: "18px" }}>Filter Properties</DialogTitle>
        <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
          <Box
            sx={{
              display: "flex",
              gap: 1.5,
              mb: 2,
            }}
          >
            {["Sale", "Rent", "Both"].map((label) => (
              <Button
                key={label}
                variant="outlined"
                onClick={() => setSelectedType(label)}
                sx={{
                  color: selectedType === label ? Colors.white : Colors.primary,
                  borderColor: Colors.primary,
                  borderRadius: "8px",
                  px: 3,
                  textTransform: "none",
                  backgroundColor: selectedType === label ? Colors.primary : "transparent",
                  "&:hover": {
                    backgroundColor: selectedType === label ? Colors.primary : "rgba(255,255,255,0.1)",
                    opacity: 0.9,
                  },
                }}
              >
                {label}
              </Button>
            ))}
          </Box>
          {/* Location Input */}
          <InputBase
            fullWidth
            value={filters.location}
            onChange={(e) => setFilters({ ...filters, location: e.target.value })}
            placeholder="Area, project or community"
            startAdornment={<SearchIcon sx={{ color: "gray", mr: 1 }} />}
            sx={{
              px: 1,
              py: 1.5,
              border: "1px solid #ccc",
              borderRadius: "8px",
            }}
          />

          {/* Property Type */}
          {/* <FormControl fullWidth>
            <Select
              value={filters.propertyType}
              onChange={(e) =>
                setFilters({ ...filters, propertyType: e.target.value })
              }
              displayEmpty
              size="small"
            >
              <MenuItem value="">Select Type</MenuItem>
              <MenuItem value="commercialOffice">Commercial Office</MenuItem>
            </Select>
          </FormControl>

          <Accordion
            elevation={0}
            sx={{
              border: "1px solid #e2e8f0",
              borderRadius: 2,
              "& .MuiAccordionSummary-root": {
                minHeight: "4px !important",
              },
            }}
          >
            <AccordionSummary expandIcon={<ExpandMore />}>
              <Typography variant="body2">Price Range</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Box sx={{ mb: 3 }}>
                <Typography variant="body2" sx={{ mb: 2, fontWeight: 600 }}>
                  Price Range (AED)
                </Typography>
                <Slider
                  value={filters.priceRange}
                  onChange={(e, newValue) =>
                    setFilters({ ...filters, priceRange: newValue })
                  }
                  valueLabelDisplay="auto"
                  min={maxMin?.min_price || 0}
                  max={maxMin?.max_price || 10000000}
                  step={100000}
                  valueLabelFormat={(value) => `${value}AED`}
                  sx={{
                    color: Colors.primary,
                  }}
                />
              </Box>
            </AccordionDetails>
          </Accordion> */}
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={() => setOpenFilterModal(false)}>
            Close
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              setOpenFilterModal(false)
              handleSearch()
            }}
            sx={{
              backgroundColor: Colors.primary,
              "&:hover": {
                backgroundColor: Colors.primary,
                opacity: 0.8,
              },
            }}
          >
            Search
          </Button>
        </DialogActions>
      </Dialog>
    </Box >
  )
}

export default Home
